/**
 * Category Page - Redirects to Products Page
 *
 * Individual category pages now redirect to /products?category=slug
 * for a simpler and more consistent user experience
 */

import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export function AliExpressCategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to products page with category filter
    if (slug) {
      navigate(`/products?category=${slug}`, { replace: true });
    } else {
      navigate('/categories', { replace: true });
    }
  }, [slug, navigate]);

  return null;
}

export default AliExpressCategoryPage;
